import { jsxs as a, jsx as r } from "react/jsx-runtime";
import { useState as b, useRef as d, useEffect as m } from "react";
import { classes as i } from "../../utils/helpers.js";
import { blockLayoutsMap as h } from "../../settings.js";
import { C as k } from "../../chevron-left-DmvQntvu.mjs";
import '../../assets/InfoPanel.css';const l = {
  "info-panel": "_info-panel_1j4w6_1",
  "info-panel__back-btn": "_info-panel__back-btn_1j4w6_19"
};
function N({
  layoutComponent: e = { layout: "", props: {} },
  onBackClicked: s = () => {
  },
  backButtonLabel: c = "Back to List",
  classname: y = ""
}) {
  const [f, L] = b(null), [t, u] = b("entering"), n = d(null), p = d(null), _ = (o) => {
    p.current = o, u("exiting"), n.current.scrollTo({
      top: n.current.offsetTop,
      left: 0,
      behaviour: "instant"
    });
  };
  return m(() => {
    async function o() {
      L(h.get(e.layout));
    }
    o();
  }, [e.layout]), m(() => {
    n.current !== null && (t === "exiting" && n.current.addEventListener("animationend", () => {
      s(p.current);
    }, { once: !0 }), t === "entering" && n.current.addEventListener("animationend", () => {
      u("idle");
    }, { once: !0 }));
  }, [t, s]), /* @__PURE__ */ a("div", { className: i([l["info-panel"], `${y}`]), "data-state": t, ref: n, children: [
    /* @__PURE__ */ a(
      "button",
      {
        className: i([l["info-panel__back-btn"], "info-panel__back-btn"]),
        type: "button",
        onClick: _,
        children: [
          /* @__PURE__ */ r(k, {}),
          c
        ]
      }
    ),
    f !== null && /* @__PURE__ */ r(f, { ...e.props }),
    /* @__PURE__ */ a(
      "button",
      {
        className: i([l["info-panel__back-btn"], "info-panel__back-btn"]),
        type: "button",
        onClick: _,
        children: [
          /* @__PURE__ */ r(k, {}),
          c
        ]
      }
    )
  ] });
}
export {
  N as InfoPanel,
  N as default
};
